import React from "react";
import history from "utils/history";
import { ROUTES } from "routes";

const SmsLimitMessage = () => {
  return (
    <span>
      You have used up your monthly SMS limit. To purchase additional SMS
      credits, click
      <button
        onClick={() =>
          history.push(`${ROUTES.SETTINGS}?key=9&outerKey=Purchase`)
        }
        style={{
          border: "none",
          padding: 0,
          background: "none",
          color: "#1890ff",
          cursor: "pointer",
        }}
      >
        &nbsp;here
      </button>
      .
    </span>
  );
};

export default SmsLimitMessage;
